/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPoe
 */
export interface SingleTurnChatInferencerPoe {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPoe
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPoe
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPoe
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPoe
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerPoe
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPoe
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPoe
   */
  assistantId: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPoe interface.
 */
export function instanceOfSingleTurnChatInferencerPoe(value: object): value is SingleTurnChatInferencerPoe {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPoeFromJSON(json: any): SingleTurnChatInferencerPoe {
  return SingleTurnChatInferencerPoeFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPoeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPoe {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
  };
}

export function SingleTurnChatInferencerPoeToJSON(
  value?: Omit<SingleTurnChatInferencerPoe, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
  };
}
